<template>
  <div>
    <component
      v-bind:is="currentComponent"
      :id="routeParams.id"
      @changeNotification="changeNotification"
    />
  </div>
</template>

<script>
import baseView from '../base.vue';
import appInfo from '../../app-info';

import { mapActions } from 'vuex'

import NotificationStatusChange from './types/status-change.vue';
import NotificationIpChange from './types/ip-change.vue';
import NotificationMinConsumableLevel from './types/min-consumable-level.vue';
import NotificationPartReplacement from './types/part-replacement.vue';
import NotificationReport from './types/report.vue';
import NotificationCounters from './types/counters.vue';

import { DataBacked } from "@/mixins/dataBackedMixin";

const notificationType = {
  "STATUS_CHANGE": 'NotificationStatusChange',
  "IP_CHANGE": 'NotificationIpChange',
  "MIN_CONSUMABLE_LEVEL": 'NotificationMinConsumableLevel',
  "PART_REPLACEMENT": 'NotificationPartReplacement',
  "REPORT": 'NotificationReport',
  "COUNTERS": 'NotificationCounters',
};

export default {
  name: 'NotificationDetail',
  extends: baseView,
  mixins: [ DataBacked ],
  components: {
    NotificationStatusChange, NotificationIpChange, NotificationMinConsumableLevel, NotificationPartReplacement, NotificationReport, NotificationCounters
  },
  data() {
    return {
      routeParams: null,
      currentComponent: null,
    }
  },
  methods: {
    ...mapActions([
      'setNotification',
      'setCreatedNotification',
      'setLocations',
      'setSubscribers',
    ]),
    changeNotification(type) {
      this.currentComponent = notificationType[type];
    },
    async init() {
      try {
        this.setLocations();
        this.setSubscribers();
      } catch (error) {
        this.onDataError(error);
      }
    }
  },
  async created() {
    document.title = `${appInfo.title} - ${this.$t('notification.title')}`;
  },
  beforeDestroy() {
    this.setNotification({});
    this.setCreatedNotification({});
  },
  watch: {
    '$route.params': {
      handler: async function(params) {
        this.routeParams = params;
        this.init();
        if (params.notification && params.notification.code === 'REPORT')
          this.currentComponent = notificationType['REPORT'];
        else
          this.currentComponent = params.type ? notificationType[params.type] : notificationType['STATUS_CHANGE'];
      },
      deep: true,
      immediate: true
    },
  }
}
</script>

<style lang="scss">
.commonproperties .dx-form-group-content {
  padding-bottom: 0 !important;
}

.dx-button-mode-contained.dx-button-default .dx-icon-add {
  color: #fff !important;
}

.recipients {
  display: flex;

  .recipient-info {
    display: flex;
  }
}

.system-label {
  user-select: none;
}

.time-box {
  margin-left: 8px;

  label span {
    width: auto !important;
  }
}

.dx-item {
  margin-bottom: 10px;
}

.dx-popup-title.dx-toolbar .dx-toolbar-before {
  width: 100%;
}
</style>